import { alpha, lighten } from "@mui/system";

const styles = (theme) => ({
  containerNoTickets: {
    width: "100%",
    height: "100%",

    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    pt: 2,
  },
  containerTextNoTicketsError: {
    position: "absolute",
    left: "45%",
    top: "25%",
    transform: "translateX(-50%)",
    "@media (max-width: 700px)": {
      left: "38%",
    },
    "@media (max-width: 600px)": {
      left: "40%",
      top: "20%",
    },
    "@media (max-width: 430px)": {
      left: "38%",
      top: "18%",
    },
  },
  containerImgNoTickets: {
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  containerTextNoTickets: {
    position: "absolute",
    left: "45%",
    top: "20%",
    transform: "translateX(-50%)",
    "@media (max-width: 700px)": {
      top: "15%",
    },
    "@media (max-width: 600px)": {
      left: "40%",
      top: "12%",
    },
    "@media (max-width: 430px)": {
      left: "40%",
      top: "10%",
    },
  },
  containerPaper: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: theme.palette.background.paper,
    padding: "20px",

    borderRadius: "16px",
    width: "100%",
    gap: 2,
  },

  tabs: {
    minHeight: 36, // reduz altura total das tabs
  },
  filterAutocomplete: {
    fontSize: "0.75rem", // diminui fonte geral
  },
  paperNoTickets: {
    width: "100%",

    height: "65vh",

    position: "relative",
    overflow: "hidden",
  },
  tab: { minHeight: 36, paddingY: 0.5 },
  container: {
    display: "flex",
    flexDirection: "column",
    gap: 1.5,
  },
  tab: {
    mt: 1.5,
    minHeight: 28,
    maxHeight: 26,
    px: 3,
    mr: 0.4,
    fontSize: "0.875rem",
    fontWeight: 500,
    textTransform: "none",
    borderTopLeftRadius: "10px",
    borderTopRightRadius: "10px",
    width: "80px",
    display: "flex",
    alignItems: "center",
    gap: 1,
    fontSize: "1rem",
  },
  tabs: {
    "& .MuiTabs-indicator": {
      display: "flex",
      justifyContent: "center",
      borderRadius: "5px 5px 0 0",
      p: 0.2,
      mb: 0.5,
    },
    "& button": {
      textTransform: "none",
    },

    width: "100%",
    "& .MuiTabs-flexContainer": {
      gap: 0.5,
    },
  },
  boxTabs: {
    p: 0,
    display: "flex",
    alignItems: "center",
    gap: 1,
    fontSize: "1rem",
    width: "100%",
    justifyContent: "space-between",
  },
  stylesChips: {
    backgroundColor: alpha(theme.palette.primary.main, 0.2),
    color:
      theme.palette.mode === "dark"
        ? theme.palette.primary.light
        : theme.palette.primary.dark,
    fontWeight: "bold",
    height: "16px",
    minWidth: "16px",
    width: "100%",
    px: 0.5,

    // Garante que o próprio Chip centralize seu conteúdo
    display: "flex",
    justifyContent: "center",
    alignItems: "center",

    "&.MuiChip-root": {
      borderRadius: 1,
    },

    // Ajustes na classe interna do label
    "& .MuiChip-label": {
      padding: 0,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      lineHeight: 1,
    },
  },

  switch: {
    width: 42,
    height: 24,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 0.2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor: theme.palette.primary.main,
          opacity: 1,
          border: 0,
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: theme.palette.primary.main,
        border: "6px solid #fff",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color:
          theme.palette.mode === "dark"
            ? theme.palette.grey[600]
            : theme.palette.grey[100],
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: theme.palette.mode === "dark" ? 0.3 : 0.7,
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 22,
      height: 22,
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor:
        theme.palette.mode === "dark"
          ? lighten(theme.palette.colors.black.dark, 0.09)
          : theme.palette.colors.gray.medium,
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
    },
  },
  boxSwitch: {
    display: "flex",
    gap: 2,
    flexWrap: "wrap",
    border: "1px solid",
    borderColor: theme.palette.divider,
    borderRadius: "12px",
    p: 1.5,
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
    "&:hover": {
      bgcolor: alpha(theme.palette.primary.main, 0.02),
    },
  },
  iconSwitch: {
    fontSize: 22,
    color: theme.palette.colors.white.lighter,
  },
});
export default styles;
